import React from "react";
import { lang } from "../../i18nLang";
import { Button, TextField, styled } from "@material-ui/core";
import { Title1 } from "../UI/Typographies";
import PasswordField from "../UI/Fields/PasswordField";

const ButtonRecover = styled(Button)(({ theme }) => ({
  transition: "none",
  padding: 0,
  marginTop: theme.spacing(3),
  fontSize: "0.7rem",
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

const ButtonLogin = styled(Button)(({ theme }) => ({
  display: "block",
  paddingRight: theme.spacing(10),
  paddingLeft: theme.spacing(10),
  margin: "0 auto",
  marginTop: theme.spacing(6),
}));

type IProps = {
  onSubmit: Function;
  onClickRecover: Function;
};

class LoginForm extends React.Component<IProps> {
  state = {
    email: "",
    password: "",
  };

  handleChangeEmail = (ev) => {
    const email = ev.target.value;
    this.setState({ email });
  };

  handleChangePassword = (ev) => {
    const password = ev.target.value;
    this.setState({ password });
  };

  handleClickRecoverPass = () => {
    this.props.onClickRecover();
  };

  handleSubmit = async (ev) => {
    ev.preventDefault();
    await this.props.onSubmit({
      email: this.state.email,
      password: this.state.password,
    });
  };

  render() {
    const disableLogin =
      this.state.email.length === 0 || this.state.password.length === 0;
    return (
      <form onSubmit={this.handleSubmit}>
        <Title1>{lang("login.title")}</Title1>
        <TextField
          id="txtEmail"
          label="E-mail"
          fullWidth
          onChange={this.handleChangeEmail}
          value={this.state.email}
          margin="normal"
        />
        <PasswordField
          id="txtPassword"
          label={lang("password")}
          value={this.state.password}
          onChange={this.handleChangePassword}
          fullWidth
        />

        <ButtonRecover
          type="button"
          variant="text"
          color="primary"
          onClick={this.handleClickRecoverPass}
        >
          {lang("login.forgotPassword")}
        </ButtonRecover>
        <ButtonLogin
          type="submit"
          color="primary"
          variant="contained"
          disabled={disableLogin}
        >
          {lang("start")}
        </ButtonLogin>
      </form>
    );
  }
}

export default LoginForm;
